﻿import { collection, doc } from 'firebase/firestore';
import { db } from './config';

export const userDoc = (uid: string) => doc(db, 'users', uid);
export const transactionsCol = (uid: string) => collection(db, 'users', uid, 'transactions');
export const plansCol = (uid: string) => collection(db, 'users', uid, 'plans');
export const paymentsCol = (uid: string) => collection(db, 'users', uid, 'planPayments');
export const crdrCol = (uid: string) => collection(db, 'users', uid, 'crdr');
export const accountsCol = (uid: string) => collection(db, 'users', uid, 'accounts');
export const accountLedgerCol = (uid: string) => collection(db, 'users', uid, 'accountLedger');
export const balanceAuditsCol = (uid: string) => collection(db, 'users', uid, 'balanceAudits');
export const budgetsCol = (uid: string) => collection(db, 'users', uid, 'budgets');
export const mastersCol = (uid: string) => collection(db, 'users', uid, 'masters');
export const contactsCol = (uid: string) => collection(db, 'users', uid, 'contacts');
export const summariesCol = (uid: string) => collection(db, 'users', uid, 'monthlySummaries');
export const notificationsCol = (uid: string) => collection(db, 'users', uid, 'notifications');
export const notificationSettingsDoc = (uid: string) => doc(db, 'users', uid, 'settings', 'notifications');
export const notificationDevicesCol = (uid: string) => collection(db, 'users', uid, 'notificationDevices');
export const notificationDeliveriesCol = (uid: string) => collection(db, 'users', uid, 'notificationDeliveries');
export const monthlyPeriodsCol = (uid: string) => collection(db, 'users', uid, 'monthlyPeriods');
export const monthlyPeriodDoc = (uid: string, key: string) => doc(db, 'users', uid, 'monthlyPeriods', key);
export const monthlyPeriodEventsCol = (uid: string, key: string) => collection(db, 'users', uid, 'monthlyPeriods', key, 'events');
